import { QA_NAME_TASK_TABLE_ROW_YES_NO_STATUS } from './TaskTableRowYesNoStatus.constants'

export function getTaskTableRowYesNoStatusQaName(type) {
  return QA_NAME_TASK_TABLE_ROW_YES_NO_STATUS[type]
}

// Clicking the active answer clears it: yes/no is a nullable value, not a radio group.
export function getTaskTableRowYesNoStatusNextValue(yesno, type) {
  return yesno === type ? null : type
}
